import React, { Component } from 'react';
class AwardsAndRankings extends Component {
  constructor() {
    super();
    this.state = {
    };
  }

  componentDidMount() {

  }


  render() {
    return (
      <div class="container-xxl mt-5" id="awards_rankings">

          {/*<div class="container inner_con mb-5">
              <div class="row g-4">
                <h1 class="text-start wow fadeInUp title_view" data-wow-delay="0.1s">Firms</h1>
                  <div class="col-lg-3 col-sm-6 wow fadeInUp" data-wow-delay="0.1s">
                      <a class="cat-item rounded p-4 card-height card_awards" href="">
                      <div class="d-flex align-items-center mb-3">
                          <img class="img-fluid flex-shrink-0 rounded" src="/assets/img/a1.png" />
                      </div>
                          <h5 class="mb-1">Awards Ttile</h5>
                          <small><i>Date: 12/02/2025</i></small>
                          <p class="mt-2">Lorem Ipsum is simply dummy text of the printing and typesetting industry.</p>
                      </a>
                  </div>

                  <div class="col-lg-3 col-sm-6 wow fadeInUp" data-wow-delay="0.1s">
                      <a class="cat-item rounded p-4 card-height card_awards" href="">
                      <div class="d-flex align-items-center mb-3">
                          <img class="img-fluid flex-shrink-0 rounded" src="/assets/img/a2.png" />
                      </div>
                          <h5 class="mb-1">Awards Ttile</h5>
                          <small><i>Date: 12/02/2025</i></small>
                          <p class="mt-2">Lorem Ipsum is simply dummy text of the printing and typesetting industry.</p>
                      </a>
                  </div>

                  <div class="col-lg-3 col-sm-6 wow fadeInUp" data-wow-delay="0.1s">
                      <a class="cat-item rounded p-4 card-height card_awards" href="">
                      <div class="d-flex align-items-center mb-3">
                          <img class="img-fluid flex-shrink-0 rounded" src="/assets/img/a1.png" />
                      </div>
                          <h5 class="mb-1">Awards Ttile</h5>
                          <small><i>Date: 12/02/2025</i></small>
                          <p class="mt-2">Lorem Ipsum is simply dummy text of the printing and typesetting industry.</p>
                      </a>
                  </div>

                  <div class="col-lg-3 col-sm-6 wow fadeInUp" data-wow-delay="0.1s">
                      <a class="cat-item rounded p-4 card-height card_awards" href="">
                      <div class="d-flex align-items-center mb-3">
                          <img class="img-fluid flex-shrink-0 rounded" src="/assets/img/a2.png" />
                      </div>
                          <h5 class="mb-1">Awards Ttile</h5>
                          <small><i>Date: 12/02/2025</i></small>
                          <p class="mt-2">Lorem Ipsum is simply dummy text of the printing and typesetting industry.</p>
                      </a>
                  </div>





               </div>
          </div>*/}

          <div class="container inner_con mb-5">
              <div class="row g-4 mb-5">
                  <h1 class="text-start wow fadeInUp title_view" data-wow-delay="0.1s">Partners</h1>

                  <div class="col-lg-3 col-sm-6 wow fadeInUp" data-wow-delay="0.1s">
                      <a class="cat-item rounded p-4 card-height card_awards" href="">
                      <div class="d-flex align-items-center mb-3">
                          <img class="img-fluid flex-shrink-0 rounded" src="/assets/img/awards/IndiaLegalTechConclave.jpeg" />
                      </div>
                          <h5 class="mb-1">India Legal Tech Conclave & Awards 2024</h5>
                          <small><i className="title_ye">General Counsel of the Year (Fintech Legal Compliance)</i></small>
                          <p class="mt-2 text_color mb-5">Recognised for exemplary leadership in fintech legal compliance, demonstrating strategic regulatory governance and innovation in legal risk management at ET Money – Times Internet.</p>
                      </a>
                  </div>

                  <div class="col-lg-3 col-sm-6 wow fadeInUp" data-wow-delay="0.1s">
                      <a class="cat-item rounded p-4 card-height card_awards" href="">
                      <div class="d-flex align-items-center mb-3">
                          <img class="img-fluid flex-shrink-0 rounded" src="/assets/img/awards/TradeFlock.jpeg" />
                      </div>
                          <h5 class="mb-1">Trade Flock</h5>
                          <small><i className="title_ye">10 Best Chief Legal Officers in India 2024</i></small>
                          <p class="mt-2 text_color mb-5">Honoured as one of India’s top Chief Legal Officers for driving robust legal, compliance, and secretarial excellence at LGT Wealth India.</p>
                      </a>
                  </div>

                  <div class="col-lg-3 col-sm-6 wow fadeInUp" data-wow-delay="0.1s">
                      <a class="cat-item rounded p-4 card-height card_awards" href="">
                      <div class="d-flex align-items-center mb-3">
                          <img class="img-fluid flex-shrink-0 rounded" src="/assets/img/awards/GeneralCounsel.jpeg" />
                      </div>
                          <h5 class="mb-1">General Counsel</h5>
                          <small><i className="title_ye">Vision and Innovation Awards 2024 (Critics’ Choice)</i></small>
                          <p class="mt-2 text_color mb-5">Awarded the Critics’ Choice for General Counsel in recognition of visionary legal strategy, forward-looking compliance frameworks, and impactful governance leadership.</p>
                      </a>
                  </div>



               </div>

          </div>


      </div>
    );
  }
}

export default AwardsAndRankings;
